const NONE_VALUES = new Set([
  "",
  "-",
  "--",
  "n/a",
  "na",
  "n.a.",
  "no",
  "none",
  "nil",
  "nope",
  "no allergies",
  "no allergy",
  "none declared",
  "not applicable",
  "nothing",
]);

/** True when a free-text field actually declares something (i.e. is not blank or a "none"-style answer). */
export function hasDeclaredValue(value: unknown): boolean {
  if (typeof value !== "string") return false;
  return !NONE_VALUES.has(value.trim().toLowerCase().replace(/[.!]+$/, ""));
}

/** True when the submission declares a real allergy. */
export function hasAllergy(value: unknown): boolean {
  return hasDeclaredValue(value);
}

/** Display helper: shows the declared text, or a neutral "None declared". */
export function displayDeclared(value: unknown, noneLabel = "None declared"): string {
  return hasDeclaredValue(value) ? String(value).trim() : noneLabel;
}
